/**
 * Keycloak adapter utility to bridge react-oidc-context with legacy keycloak-js API usage
 * This provides backwards compatibility for code that expects keycloak instance properties
 */

import jwtDecode from 'jwt-decode';

let authInstance: any = null;

export const setAuthInstance = (auth: any) => {
  authInstance = auth;
};

export const getAuthInstance = () => {
  return authInstance;
};

export const getAccessToken = () => {
  const auth = getAuthInstance();
  return auth?.user?.access_token;
};

export const isAuthenticated = () => {
  const auth = getAuthInstance();
  return auth?.isAuthenticated || false;
};

export const getUserRoles = (): string[] => {
  const auth = getAuthInstance();
  if (!auth?.user?.access_token) return [];

  try {
    // Decode the access token to get roles
    const decodedToken: any = jwtDecode(auth.user.access_token);
    const roles = decodedToken.roles || [];
    const removedRoles = ['default-roles-torqi', 'uma_authorization', 'offline_access'];
    return roles.filter((role: string) => !removedRoles.includes(role));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error decoding access token:', error);
    return [];
  }
};
